const { queryHomepageRootElement, queryStorepageRootElement } = require('./queryElement');

/**
 * Get the ID associated to a home page (Page Designer)
 * @returns {string} ID of the home page
 */
const getHomePageId = () => queryHomepageRootElement()?.dataset.pageId ?? null;

/**
 * Get the ID associated to a store page (Page Designer)
 * @returns {string} ID of the store page
 */
const getStorePageId = () => queryStorepageRootElement()?.id ?? null;

module.exports = {
    getHomePageId,
    getStorePageId
};
